<template>
    <div class="container" v-show="show">
        <h2 class="series-title mincho">{{series.series_name}}</h2>
        <div class="row">
            <div class="col-md-3">
                <div class="series-desc" v-html="$filters.wrap(series.description)" v-if="series.description">
                </div>
                <div v-if="articles.length" class="d-none d-lg-block">
                    <article-card v-for="a in articles" :key="'article-' + a.id"
                        :article="a"></article-card>
                </div>
            </div>
            <div class="col-md-9">
                <div v-if="books.length > 0 && books.length < 5">
                    <book-card v-for="b in books"
                        :book="b"
                        :key="b.id"
                        :author="true"
                        :favorite="false"
                        :isActive="b.id == $route.query.book_id"></book-card>
                </div>
                <div v-else-if="books.length >= 5">
                    <div class="row" v-for="(bag, n) in seriesNovels" :key="'novel-row-' +n">
                        <div :class="{
                            'col-md-12': n === 0,
                            'col-md-6': n !== 0,
                        }" v-for="b in bag" :key="'novel-' +b.id">
                            <book-card :book="b" @updated="loadBooks()" v-if="n === 0"></book-card>
                            <book-card-mini :book="b" @updated="loadBooks()" v-else></book-card-mini>
                        </div>
                    </div>
                </div>
                <div v-else>
                    このシリーズには小説がありません。
                </div>
                <div v-if="articles.length" class="d-block d-lg-none">
                    <article-card v-for="a in articles" :key="'article-' + a.id"
                        :article="a"></article-card>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.series-title {
    text-align: center;
    padding: 2rem 0 3rem;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.series-desc {
    max-width: 860px;
    margin: 0 auto 3rem;
}
.container {
    max-width: 1480px;
}
</style>

<script>
import bookCard from "../bookCard";
import bookCardMini from "../bookCardMini";
import articleCard from "../articleCard";
export default {
    components: {
        bookCard,
        bookCardMini,
        articleCard,
    },
    data() {
        return {
            series: {},
            books: [],
            articles: [],
            show: false,
        }
    },
    methods: {
        load() {
            axios.get("/author/series/get", {params: {series_id: this.$route.params.series_id}}).then(res => {
                this.series = res.data.series;
                this.books = res.data.books;
                this.show = true;
                setTimeout(() => {this.autoScroll()});
            }).catch(err => { alert.err(err.response) });
        },
        loadArticles() {
            axios.get("/author/articles/series", {params: {id: this.$route.params.series_id}}).then(res => {
                this.articles = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        autoScroll() {
            if (this.$route.query.book_id) {
                const scrollTop = $("#book-card-" + this.$route.query.book_id)[0].offsetTop - 76;
                $("html,body").animate({scrollTop: scrollTop});
            }
        }
    },
    computed: {
        seriesNovels() {
            let seriesNovels = [];
            if (this.books.length) {
                let bag = [];
                seriesNovels.push([this.books[0]]);
                for (let i = 1; i < this.books.length; i++) {
                    bag.push(this.books[i]);
                    if (i % 2 === 0) {
                        seriesNovels.push(bag);
                        bag = [];
                    }
                }
                if (bag.length) {
                    seriesNovels.push(bag);
                }
            }
            return seriesNovels;
        }
    },
    mounted() {
        this.load();
        this.loadArticles();
    }
}
</script>